import { isEmpty } from 'lodash';

import Experts from 'hb-react/shared/apps/Topics/components/Experts';
import { topicElementIsVisibleOnPublicPage } from 'hb-react/shared/apps/Topics/utils/topicElementIsVisibleOnPublicPage';

import style from '../index.module.scss';

const ExpertsWrapper = ({ currentUser, topic, expertStore }) =>
  topicElementIsVisibleOnPublicPage(currentUser, topic, 'experts') &&
  !isEmpty(topic.experts) && (
    <div className="flex soft-double--bottom">
      <div className={`flex-grow--1 ${style['homepage-container']}`}>
        <h2 className="h1 soft-double--ends flex flex--justify-center">
          {topic.expert_title || __('Experts')}
        </h2>
        <Experts
          experts={topic.experts.map((expertId) =>
            expertStore.getIn(['experts', expertId.toString()]).toJS(),
          )}
        />
      </div>
    </div>
  );

export default ExpertsWrapper;
